import React, {useEffect, useState} from 'react'
import {useSelectedVariantContext} from '../../../context/SelectedVariantContext'
import ProductAttributes from '../../../product-variant/ProductAttributes'
import UploadBackgroundImage from './UploadBackgroundImage'
import {actionUpdateGalleryImage} from '../../../context/SelectedVariantContext/action'
import {usePreviewArtworks} from '../../../../../hooks/usePreviewArtworks'
import ListPlacementsContainer from './ListPlacementsContainer'

const VariantViewContainer = () => {
    const {
        dispatch,
        state: {mappedAttributes, display, previewImages, useClientMockup},
    } = useSelectedVariantContext()

    const _getSelectSize = () => {
        const selectSize = mappedAttributes.size.find((attr) => attr.is_selected)
        return selectSize.value_text
    }

    // const {fetchPreviews, pending} = usePreviewArtworks()
    //
    // useEffect(() => {
    //     fetchPreviews()
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])


    useEffect(() => {
        const images = previewImages.reduce((acc, preview) => [...acc, ...preview.images], [])
        if (!!images.length) {
            dispatch(actionUpdateGalleryImage(images))
        }
    }, [previewImages, display, dispatch])

    return (
        <div className="VariantViewContainer">
            <h2>Mockup properties</h2>
            {'size' in mappedAttributes && (
                <>
                    <div>The mockup is for "size {_getSelectSize()}"</div>
                    <div>
                        The visible design area may be proportionately larger or smaller to match the final print size
                    </div>
                </>
            )}
            <div className="ListProductLineConfirm">
                <div className="ItemCatalog View">
                    <div className="ContentItem p-0">
                        <div className="ProductVariants">
                            <ProductAttributes />
                        </div>
                    </div>
                </div>
            </div>
            <ListPlacementsContainer/>
            <UploadBackgroundImage/>
        </div>
    )
}

export default VariantViewContainer

